import { Routes } from '@angular/router';
import { AboutUsComponent } from './about-us/about-us.component';
import { FAQComponent } from './faq/faq.component';
import { WorkshopsApplicationComponent } from './workshops-application/workshops-application.component';
import { ContactUsComponent } from './contact-us/contact-us.component';

export const sharedModuleRoutes: Routes = [
  // {
  //   path: 'about-us',
  //   component: AboutUsComponent
  // },
  // {
  //   path: 'faq',
  //   component: FAQComponent
  // },
  // {
  //   path: 'workshop-application',
  //   component: WorkshopsApplicationComponent
  // },
  // {
  //   path: 'contact-us',
  //   component: ContactUsComponent
  // }
];